export function formatFipeZapValuationLabel(city: string | null | undefined): string {
  if (city) {
    return `Valorização estimada com base no índice FIPE Zap — ${city}`;
  }

  return "Valorização estimada com base no índice FIPE Zap";
}
